import React, { useEffect, useRef } from 'react';

/**
 * Kebab menu with provided items. Handles open/close externally with open flag.
 * items: Array<{ label: string, icon?: string, onClick: () => void, danger?: boolean, disabled?: boolean }>
 */
const BKebabMenu = ({ isOpen, onToggle, items = [] }) => {
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        buttonRef.current &&
        !menuRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        onToggle();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onToggle]);

  return (
    <div className="b_admin_styling-actions-popover">
      <button
        ref={buttonRef}
        className="b_admin_styling-kebab"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        aria-haspopup="menu"
        aria-expanded={isOpen}
      >
        <i className="ri-more-2-fill"></i>
      </button>
      {isOpen && (
        <div ref={menuRef} className="b_admin_styling-menu" role="menu">
          {items.map((item, idx) => (
            <button
              key={idx}
              className={`b_admin_styling-menu__item ${item.danger ? 'b_admin_styling-menu__item--danger' : ''} ${item.disabled ? 'b_admin_styling-menu__item--disabled' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                if (!item.disabled) {
                  item.onClick();
                  onToggle(); // Close menu after action
                }
              }}
              disabled={item.disabled}
              role="menuitem"
            >
              {item.icon && <i className={item.icon}></i>}
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default BKebabMenu;



